import { stylesheet } from 'typestyle';
import { flexRoot, center } from 'csstips';
import {
  buttonBlueBackground,
  buttonBlueBackgroundHover,
  borderGrayOutline
} from '@styles/general';
import { blueButton } from '@styles/buttons';

export default stylesheet({
  container: {
    ...flexRoot,
    ...center,

    flex: 1,
    position: 'relative',
    marginBottom: 2,
    zIndex: 1
  },

  // There is a div inside of the container so that the button doesn't move up
  // when opened thanks to the center alignment.
  centerAlignmentContainer: {
    flex: 1
  },

  button: {
    ...blueButton,

    color: 'white !important',

    // force in all states (hover, active, etc)
    background: `${buttonBlueBackground} !important`,

    width: '100%',
    paddingRight: '30px !important',
    minWidth: '190px',
    flexBasis: '100%',
    whiteSpace: 'nowrap',

    i: {
      position: 'absolute',
      right: 12,
      top: 15,
      fontSize: '0.7em'
    },

    $nest: {
      '&.open': {
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0
      }
    }
  },
  actionList: {
    position: 'absolute',
    background: 'white',
    width: '100%'
  },
  actionListItem: {
    padding: '9px 20px',
    cursor: 'pointer',
    borderLeft: `solid 1px ${borderGrayOutline}`,
    borderRight: `solid 1px ${borderGrayOutline}`,
    textAlign: 'left',

    $nest: {
      '&:last-child': {
        borderBottom: `solid 1px ${borderGrayOutline}`,
        borderBottomLeftRadius: 6,
        borderBottomRightRadius: 6
      },

      '&:hover': {
        background: buttonBlueBackgroundHover,
        borderColor: buttonBlueBackground,
        color: 'white'
      }
    }
  }
});
